module.exports = __webpack_public_path__ + "img/im.im3b9ec59.svg";